import styled from 'styled-components';

export const Container = styled.div`
  margin: 15px;
`;

export const Timestamp = styled.div`
  font-size: 12px;
`;
